<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <!-- 主题内容 -->
    <div class="b-center-container">
      <!-- 富文本 -->
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
      <!--
      <v-footer></v-footer>
      <v-copy></v-copy>
      -->
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/en/";
import Nav from "@/components/nav/en/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/en/"
import Footer from "@/components/footer/"
import Contact from "@/components/contact/en/";
export default {
  data () {
    return {
      richText: '',
    };
  },
  mounted () {
    this.richText = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">Model Animal Center</span></p>'
      //+ '<div style="margin-left : 40px; margin-bottom: 20px"><div style="font-size: 20px;"><b style="color: #033d80; "> | </b> 简介</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:70%; height:100%;">'
      + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify"><span style="font-size: 16px">Model Animal Center provides full services to animal studies including generation and phenotyping of genetically modified animal models for biomedical research.</span></p>'
      + '<p style="margin-bottom : 10px; margin-right : 50px;text-align: justify"><span style="font-size: 16px">＊ Animal Modification Service</span></p>'
      + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify"><span style="font-size: 16px">The center generates genetically manipulated mice, rats and cell lines such as \n' +
      'knockout (KO), conditional knockout (CKO) and knock-in, using CRISPR/Cas9 \n' +
      'technologies and gene targeting in embryonic stem cells. We also help create a cell \n' +
      'line-derived xenograft model (CDX), patient-derived tumor xenograft model \n' +
      '(PDX), and surgery/drug-induced animal model for your project.</span></p>'
      + '<p style="margin-bottom : 10px; margin-right : 50px;text-align: justify"><span style="font-size: 16px">＊ Phenotyping Service</span></p>'
      + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify"><span style="font-size: 16px">The center provides full services to phenotyping analyses including physiology and biochemistry tests, pathologic diagnosis, behavioral measurements and imaging analyses (type-B ultrasonic, Micro-CT, PET/CT, SPECT/CT, MRI, etc.).</span></p>'
      + '<p style="margin-bottom : 10px; margin-right : 50px;text-align: justify"><span style="font-size: 16px">＊ Full packages Service</span></p>'
      + '<p style="margin-bottom : 20px; margin-right : 50px;text-align: justify"><span style="font-size: 16px">The center offers full-service packages as well as ad-hoc services including molecular biology experiments, cell culture, animal modification and breeding, phenotyping to qualify researches in disease mechanism, preclinical efficacy, drug evaluation ,etc.</span></p>'

      + '</div>'


      + '<div id="right" style="float:left ; width:30%; height:100%;">'
      + '<p style="margin-left : 50px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/zhaoxiawang.jpg" style="float: center; width: 200px;  margin-right: 40px;"  border="0" vspace="0" alt=""></p>'
      + '<p style="margin-bottom : 20px;text-align: justify"><span style="font-size: 12px;"><b>Director: Zhaoxia Wang</b><br>Ph.D., Professor, Director<br>zhaoxiaw@sjtu.edu.cn<br>Director of Laboratory Animal Center and ModelAnimal Center, Director of Institutional Animal Care and Use Committee, Shanghai Jiao Tong University.</span></p>'
      + '</div>'
      + '<p style="margin-left : 20px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/model_animal_en.jpg" style="float: left; width: 1200px;  margin-right: 20px;" border="0" vspace="0" alt=""></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">Contact</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Zhaoxia Wang</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: zhaoxiaw@sjtu.edu.cn</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Phone: +86-021 - 34208048，+8613636452950</span></p>'
      + '<p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-footer": Footer,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service5/en/index.vue